import React, { Component } from "react";
import { Link } from "react-router-dom";
import FormStep from "../../common/components/formStep";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";

interface IProps {
    history: any;
}
interface IState {}
export class SecurityMandateDetails extends Component<IProps, IState> {
    steps = [
        { title: "Vehicle" },
        { title: "Loan" },
        { title: "Personal" },
        { title: "e-Mandate", active: true },
        { title: "Confirmation" },
    ];
    render() {
        window.scrollTo(0, 0);
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="securtiy-mandate-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <FormStep steps={this.steps} />
                            <h1 className="openSans-Reg text-black my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                                Security Mandate Instruction Form
                            </h1>
                            <div className="w-full">
                                <div className="flex flex-wrap w-full my-5">
                                    <div className="w-full">
                                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                                Date
                                            </label>
                                            <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                                <span>04/03/2021</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <div className="relative w-full md:w-1/2 my-6 md:my-10">
                                            <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                                I/We hereby Authorise HDFC Bank
                                                to debit
                                            </p>
                                        </div>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            Bank A/C Number
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>65479E11</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            With Bank
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>
                                                ABHYUDAYA COOPERATIVE BANK
                                                LIMITED
                                            </span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            A/c type
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>SAVINGS</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            A/c holder name
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>
                                                Shashank Arolkar hgfhgf hgfhgh
                                            </span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            IFSC Code
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>ABHY0065006</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            MICR Code
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>400065006</span>
                                        </p>
                                    </div>
                                    <div className="w-full">
                                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                                Branch Name
                                            </label>
                                            <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                                <span>Fort</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            An Amount of Rupees (Words)
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>
                                                Seven Lakh Twenty Thousand Only
                                            </span>
                                        </p>
                                    </div>
                                    <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            An Amount of Rupees (Figures)
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>7,20,000.00</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            Frequency
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>ADHOC</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            Debit Type
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>Maximum Amount</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            Reference 1
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>20099023s</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            Reference 2
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>Auto Loan</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            Phone No.
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>9699592383</span>
                                        </p>
                                    </div>
                                    <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            E-mail ID
                                        </label>
                                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                            <span>
                                                ranjith.krishnankutty@indigo.co.in
                                            </span>
                                        </p>
                                    </div>
                                    <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                        <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                            PeriodFrom
                                        </label>
                                        <div className="flex flex-wrap w-full">
                                            <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 md:mb-0 md:pb-0 pr-0 md:pr-2">
                                                <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                                    From
                                                </label>
                                                <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                                    <span>05/04/2021</span>
                                                </p>
                                            </div>
                                            <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 md:mb-0 md:pb-0 pl-0 md:pl-2">
                                                <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                                    To
                                                </label>
                                                <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                                    <span></span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4">
                                            <label className="custom-inputs inline-flex items-start md:items-center">
                                                <input
                                                    type="checkbox"
                                                    name=""
                                                    value=""
                                                    disabled
                                                    checked
                                                />
                                                <span></span>
                                                <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                                    Until cancelled
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full openSans-Reg text-sm md:text-base lg:text-lg my-4">
                                    <p className="my-4">
                                        This is to confirm that the declaration
                                        has been carefully read, understood
                                        &amp; made by me/us.
                                    </p>
                                    <p className="my-4">
                                        Kindly note the Security e-Mandate is
                                        taken in lieu of Physical cheques which
                                        is taken in Non digital Mode (Physical
                                        Processing).
                                    </p>
                                </div>
                                <div className="w-full flex flex-wrap my-8">
                                    <button
                                        className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue  mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4 transition-all"
                                        title="I Agree"
                                    >
                                        I Agree
                                    </button>
                                    <button
                                        className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                                        title="I Disagree"
                                    >
                                        I Disagree
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default SecurityMandateDetails;
